import { useEffect } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuthStore } from '../store/authStore';
import { useConfigStore } from '../store/configStore';

export default function LoginRequired() {
  const { checkSession } = useAuthStore();
  const isDev = useConfigStore((s) => s.dev);
  const configLoaded = useConfigStore((s) => s.loaded);
  const fetchConfig = useConfigStore((s) => s.fetchConfig);

  useEffect(() => {
    if (!configLoaded) fetchConfig();
  }, [configLoaded, fetchConfig]);

  const handleLoginSuccess = async (credentialResponse: { credential?: string }) => {
    const credential = credentialResponse.credential;
    if (!credential) return;

    const { apiFetch } = await import('../lib/api');
    const res = await apiFetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ credential }),
    });

    if (res.ok) {
      await checkSession();
    } else {
      const data = (await res.json()) as { error?: string };
      alert(data.error || 'Login failed');
    }
  };

  const handleDevLogin = async () => {
    const { apiFetch } = await import('../lib/api');
    const res = await apiFetch('/api/auth/dev-login', { method: 'POST' });
    if (res.ok) await checkSession();
    else alert('Dev login failed');
  };

  return (
    <div className="card" style={{ maxWidth: '480px', margin: '2rem auto', textAlign: 'center' }}>
      <h2 style={{ marginTop: 0 }}>Login Required</h2>
      <p style={{ color: 'var(--muted)' }}>
        Please sign in with Google to use this feature.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
        <GoogleLogin onSuccess={handleLoginSuccess} onError={() => alert('Login failed')} />
        {isDev && (
          <>
            <span style={{ color: 'var(--muted)', fontSize: '0.8rem' }}>— or, for local dev —</span>
            <button onClick={handleDevLogin} style={{ background: '#334155', color: 'var(--text)' }}>
              Dev login (no Google)
            </button>
          </>
        )}
      </div>
    </div>
  );
}
